import type { FC, RefObject } from 'react';
import React from 'react';

import { cnSpin } from './Spin.cn';

import './Spin.css';

export interface ISpinProps {
    /**
     * Ссылка на корневой DOM-элемент компонента.
     */
    innerRef?: RefObject<HTMLDivElement>;

    /**
     * Видимость индикатора загрузки.
     */
    progress?: boolean;
    /**
     * Позиция индикатора загрузки.
     */
    position?: 'center';

    /**
     * Дополнительный класс.
     */
    className?: string;
    /**
     * Размер компонента
     *
     * @default m
     */
    size?: 'xxs' | 'xs' | 's' | 'm' | 'l';
}

/**
 * @deprecated Use import { Spinner } from '@yandex-int/hr-components/Spinner'
 */
export const Spin: FC<ISpinProps> = ({
    className,
    innerRef,
    progress,
    position,
    size = 'm',
    ...props
}) => {
    React.useEffect(() => {
        if (process.env.NODE_ENV === 'development')
            console.warn('[Spin]: Эта версия компонента устарела и скоро будет удалена');
    }, []);

    return (
        <div
            {...props}
            ref={innerRef}
            className={cnSpin({ progress, size, position }, [className])}
        />
    );
};

Spin.displayName = cnSpin();
